import { Link } from "gatsby"
import React from "react"
import { UserIcon } from "components/page-components/Icons/small"

export const AuthorsHits = ({ hits, last_entry_ref, close_search_modal }) => {
  return (
    <div className="columns is-multiline is-variable is-8">
      {hits.map(({ title, objectID, image, path }, i) => (
        <Link
          ref={
            i === Math.floor((hits.length / 20 - 1) * 20) - 1
              ? last_entry_ref
              : null
          }
          to={path}
          onClick={close_search_modal}
          className="column is-2 has-text-centered"
          key={objectID}
        >
          {!!image ? (
            <img
              src={image}
              alt={title}
              className="hoverzoom"
              style={{ width: 104, height: 104, borderRadius: "100%" }}
            />
          ) : (
            <div
              className="hoverzoom mx-auto"
              style={{
                width: 104,
                height: 104,
                borderRadius: "100%",
                backgroundColor: "#EEE",
                display: "flex",
                marginBottom: "6px",
              }}
            >
              <div className="m-auto">
                <UserIcon {...{ size: 1.5 }} />
              </div>
            </div>
          )}
          <p className="has-text-white has-text-centered">{title}</p>
        </Link>
      ))}
    </div>
  )
}
